// this is an autogenerated file from App/Account/Content/Tasks/query-get-user-location-preferences.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Tasks($user_id: uuid!, $location_id: uuid!) {
  user_location_preferences_by_pk(
    user_id: $user_id
    location_id: $location_id
  ) {
    tasks_filter_presets
  }
}

`